import React from 'react';

interface PlusIconProps {
  size?: number;
  color?: string;
}

/**
 * PlusIcon Component
 * @description A plus/add icon for adding actions
 */
export const PlusIcon: React.FC<PlusIconProps> = ({ 
  size = 16, 
  color = 'currentColor' 
}) => {
  return (
    <svg 
      fill="none" 
      stroke={color} 
      viewBox="0 0 24 24" 
      width={size} 
      height={size}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 4v16m8-8H4" />
    </svg>
  );
};

export default PlusIcon;






